import "./";
import React from "react"
import { Routes, Route,useLocation } from "react-router-dom"
import { useSelector } from "react-redux";

//Common
import { Authentication, EmailComponent, EnterEmailOTP, Login, Registration, SetNewPassword } from "./components/Login";
import { Dashboard, SideNavBar, SessionExpiredModal, LoadingPage, PageNotFound, TestPage } from "./components/Shared";

//Classes
import { EditMark, Markings, SubjectOverViewTabs } from "./components/Marking";
import { ClassHome } from "./components/Classes";
import { AssessmentMarking } from "./components/Assessment"

//SchoolAdmin
import { SchoolAdminPages } from "./components/SchoolAdmin";

//Profile
import { ProfileUpdate, PasswordUpdate } from "./components/Profile";
import { NewUser, SetPassword } from "./components/InviteUser";

//Shared
import { hasAny, SessionStorage } from "./util";
import { RolesEnum, SessionStorageKeys, NavigationBar, CommonPages, SchoolPages, PupilProgress, SchoolAdmin, InviteUser, RegistrationProcess, BigPicturePages } from "./helper";
import { B2BRegistrationFrom, B2CRegistrationForm } from "./components/RegistrationForm";


import { PupilProgressTable, StudentGraph } from "./components/PupilProgress"
import { SuperAdmin } from "./components/SuperAdmin";

//BigPicture
import { BigPicturePPR, CurriculumCoverage, DemographicsLanding, EoYPredictions, LandingPageBigPic, ProgressGraph } from "./components/BigPicture";

const App = () => {
  const token = SessionStorage.getItem(SessionStorageKeys.SessionToken)
  const accessDenied = SessionStorage.getItem(SessionStorageKeys.AccessDenied)
  SessionStorage.setItem(SessionStorageKeys.AccessDenied, 0)
  let user = useSelector((state) => state.login.user);
  const isNavCollapsed = useSelector((state) => state.styleData.isNavCollapsed)

  const location = useLocation();
  const currectLocation = location.pathname;

  const excludedPages = [
    CommonPages.setNewPassword,
    InviteUser.setPassword,
    InviteUser.newUser,
    InviteUser.newUser_,
    CommonPages.EnterEmail,
    CommonPages.login,
    CommonPages.authentication
  ];
  
  const dynamicRoutes = [
    { pattern: /^\/EnterOTPToChangePassword\/[^/]+$/ }, // Matches `/EnterOTPToChangePassword/:email`
  ];
  
  const shouldSetRelativePosition = (token, currectLocation) => {
    // Check static excluded pages
    if (!token) return false;
    if (excludedPages.includes(currectLocation)) return false;
  
    // Check dynamic routes
    return !dynamicRoutes.some(route => route.pattern.test(currectLocation));
  };

  
  return (
    <div>
      {accessDenied && accessDenied === "1" ? (<SessionExpiredModal />) :
        (<div className="nav-parent">
          <div>
            {(token && (hasAny(user.userType, [RolesEnum.Teacher, RolesEnum.LeadTeacher, RolesEnum.Admin, RolesEnum.MappixAdmin]))) && <SideNavBar />}
          </div>
          <div style={{ width: "-webkit-fill-available", position: shouldSetRelativePosition(token, currectLocation) ? "relative" : "", left: isNavCollapsed ? "80px" : "250px",backgroundColor: currectLocation === SchoolAdmin.schoolAdmin ? "#F2F2F2" : ""  }}>
            <Routes>
              <Route path={CommonPages.LoadingPage} element={<LoadingPage />} />
              <Route path={CommonPages.login} element={<Login />} />
              <Route path={CommonPages.authentication} element={<Authentication />} />
              <Route path={CommonPages.updatePassword} element={<PasswordUpdate />} />
              <Route path={CommonPages.UpdateProfile} element={<ProfileUpdate />} />
              <Route path={CommonPages.registration} element={<Registration />} />
              <Route path={CommonPages.EnterEmail} element={<EmailComponent />} />
              <Route path={CommonPages.EnterOTPToChangePassword} element={<EnterEmailOTP />} />
              <Route path={CommonPages.setNewPassword} element={<SetNewPassword />} />
              <Route path={CommonPages.sessionExpired} element={<SessionExpiredModal />} />

              <Route path={CommonPages.dashboard} element={<Dashboard />} />
              <Route path={SchoolAdmin.schoolAdmin} element={<SchoolAdminPages />} />

              <Route path={InviteUser.newUser} element={<NewUser />} />
              <Route path={InviteUser.setPassword} element={<SetPassword />} />
              <Route path={RegistrationProcess.b2bRegister} element={<B2BRegistrationFrom />} />
              <Route path={RegistrationProcess.b2cRegister} element={<B2CRegistrationForm />} />

              <Route path={SchoolPages.Assessment} element={<AssessmentMarking />} />
              <Route path={SchoolPages.subjectOverview} element={<SubjectOverViewTabs />} />
              <Route path={SchoolPages.classHome} element={<ClassHome />} />

              <Route path={SchoolPages.subjectMarkings} element={<Markings />} />
              <Route path={SchoolPages.editMarks} element={<EditMark />} />

              <Route path={PupilProgress.pupilTable} element={<PupilProgressTable />} />
              <Route path={PupilProgress.lineGraph} element={<StudentGraph />} />

              <Route path={NavigationBar.AccountSettings} element={<ProfileUpdate />} />

              <Route path={NavigationBar.SuperAdmin} element={<SuperAdmin />} />

              <Route path={BigPicturePages.landingPageBigPic} element={<LandingPageBigPic />} />
              <Route path={BigPicturePages.bigPictuePredictedProgress} element={<BigPicturePPR />} />
              <Route path={BigPicturePages.bigPictueEndOfYearPrediction} element={<EoYPredictions />} />
              <Route path={BigPicturePages.demographics} element={<DemographicsLanding />} />
              <Route path={BigPicturePages.curriculumCoverage} element={<CurriculumCoverage />} />
              <Route path={BigPicturePages.progress} element={<ProgressGraph />} />

              <Route path={CommonPages.TestPage} element={<TestPage />} />
              <Route path="*" element={<PageNotFound />} />

            </Routes>
          </div>
        </div>)}
    </div>
  );
}

export default App;